<ng-template #sidebar>
    <div class="post-view__item post-view__item-sidebar">
        <app-blog-sidebar></app-blog-sidebar>
    </div>
</ng-template>

<div class="block post-view" *ngIf="data">
    <div class="post-view__header post-header" [ngClass]="{'post-header--has-image': hasImage}">
        <div
            *ngIf="hasImage"
            class="post-header__image"
            [ngStyle]="{
                'background-image': 'url(assets/images/posts/post-1.jpg)'
            }"
        ></div>
        <div class="post-header__body">
            <div class="post-header__categories">
                <ul class="post-header__categories-list">
                    <li class="post-header__categories-item">
                        <a  class="post-header__categories-link">Latest News</a>
                    </li>
                </ul>
            </div>
            <h1 class="post-header__title">{{ data.title }}</h1>
            <div class="post-header__meta">
                <ul class="post-header__meta-list">
                    <li class="post-header__meta-item">By <a routerLink="/shop/products/{{data.get_slug}}" class="post-header__meta-link">{{ data.get_name }}</a></li>
                    <li class="post-header__meta-item">{{ data.date }}</li>
                </ul>
            </div>
        </div>
        <app-decor class="post-header__decor" type="bottom"></app-decor>
    </div>

    <div class="container">
        <div class="post-view__body">
            <ng-container *ngIf="sidebarPosition === 'start'">
                <ng-container *ngTemplateOutlet="sidebar"></ng-container>
            </ng-container>
            <div class="post-view__item post-view__item-post">
                <div class="post-view__card post">
                    <div class="post__body typography">
                        <figure>
                                <img [src]="data.image" alt="">
                        </figure>
                        <p [innerHtml]="data.description"></p>
                    </div>



                </div>

                <!-- <div class="post-view__card post-navigation">
                    <div class="post-navigation__body">
                        <a class="post-navigation__item post-navigation__item--prev" href="">
                            <div class="post-navigation__item-image">
                                <img [src]="posts[1].image" alt="">
                            </div>
                            <div class="post-navigation__item-info">
                                <div class="post-navigation__direction">
                                    <div class="post-navigation__direction-arrow">
                                        <app-icon icon="arrow-rounded-left-7x11"></app-icon>
                                    </div>
                                    <div class="post-navigation__direction-title">
                                        Previous post
                                    </div>
                                </div>
                                <div class="post-navigation__item-title">
                                    {{ posts[1].title }}
                                </div>
                            </div>
                        </a>

                        <a class="post-navigation__item post-navigation__item--next" href="">
                            <div class="post-navigation__item-info">
                                <div class="post-navigation__direction">
                                    <div class="post-navigation__direction-title">
                                        Next post
                                    </div>
                                    <div class="post-navigation__direction-arrow">
                                        <app-icon icon="arrow-rounded-right-7x11"></app-icon>
                                    </div>
                                </div>
                                <div class="post-navigation__item-title">
                                    {{ posts[2].title }}
                                </div>
                            </div>
                            <div class="post-navigation__item-image">
                                <img [src]="posts[2].image" alt="">
                            </div>
                        </a>
                    </div>
                </div> -->

            </div>
            <ng-container *ngIf="sidebarPosition === 'end'">
                <ng-container *ngTemplateOutlet="sidebar"></ng-container>
            </ng-container>
        </div>
    </div>
</div>

<app-block-space layout="before-footer"></app-block-space>
